import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PageStyles.css";

const TBA_MODE = false;

const API_URL =
  process.env.REACT_APP_API_URL?.trim() ||
  "https://us-central1-ottomun-87f07.cloudfunctions.net/api/api";

const AcademicTeam = () => {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    if (!TBA_MODE) {
      const fetchTeam = async () => {
        try {
          const res = await axios.get(`${API_URL}/academic-team`);
          // Her elemana flipped state ekliyoruz (ön/arka yüz kontrolü için)
          setTeam(res.data.map((m) => ({ ...m, flipped: false })));
        } catch (err) {
          console.error("❌ Error fetching academic team:", err);
        }
      };
      fetchTeam();
    }
  }, []);

  if (TBA_MODE) {
    return (
      <section className="tba-hero">
        <div className="tba-overlay"></div>
        <div className="tba-content">
          <h1 className="tba-heading">Ottomun Academic Team</h1>
          <h2 className="tba-soon">TO BE ANNOUNCED</h2>
          <p className="tba-message">
            Our Academic Team is being prepared with utmost care.
            <br />
            Stay tuned — details will be unveiled very soon.
          </p>
        </div>
        <div className="tba-footer">
          <p>© Ottomun Secretariat</p>
        </div>
      </section>
    );
  }

  return (
    <section className="page-section">
      <h1>Ottomun Academic Team</h1>
      <p>
        Meet the brilliant minds shaping our MUN conferences and guiding our
        delegates.
      </p>

      {team.length === 0 ? (
        <p style={{ marginTop: "30px", fontStyle: "italic" }}>
          No academic members found.
        </p>
      ) : (
        <div className="cards grid-cards">
          {team.map((member) => (
            <div
              key={member.id}
              className={`team-card ${member.flipped ? "flipped" : ""}`}
              onClick={() =>
                setTeam((prev) =>
                  prev.map((m) =>
                    m.id === member.id ? { ...m, flipped: !m.flipped } : m
                  )
                )
              }
            >
              <div className="team-card-inner">
                {/* Ön Yüz */}
                <div className="team-card-front">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={member.name}
                      className="square-photo"
                    />
                  ) : (
                    <div className="photo-placeholder">No Image</div>
                  )}
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>

                {/* Arka Yüz */}
                <div className="team-card-back">
                  <p>{member.bio || "No bio available."}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AcademicTeam;
